export enum OrderStatus {
  accepted = 'accepted',
  progress = 'progress',
  delivered = 'delivered',
  cancelled = 'cancelled',
  failed = 'failed',
}
